$(function () {
    var $section = $('.page-search');

    if (!$section.length) {
        return;
    }

    var $results = $section.find('#search-results');
    var $tabs = $section.find('.search-tab');

    var initialHtml = $results.html();
    var initialSession = $section.data('session');

    function setActiveTab(session) {
        $tabs.each(function () {
            var $tab = $(this);
            var isActive = $tab.data('session') === session;

            $tab.toggleClass('btn-primary', isActive);
            $tab.toggleClass('btn-primary-outline', !isActive);
            $tab.attr('aria-pressed', isActive ? 'true' : 'false');
        });
    }

    function applyResults(session, html) {
        $results.html(html);
        $section.data('session', session);
        setActiveTab(session);
    }

    function loadSession($tab, pushHistory) {
        if ($section.hasClass('is-loading')) {
            return;
        }

        var session = $tab.data('session');

        if (session === $section.data('session')) {
            return;
        }

        var ajaxUrl = $tab.data('ajaxUrl');
        var pageUrl = $tab.data('pageUrl');

        $section.addClass('is-loading');
        $results.addClass('opacity-50');

        $.get(ajaxUrl)
            .done(function (html) {
                applyResults(session, html);

                if (pushHistory) {
                    history.pushState({ session: session, ajaxUrl: ajaxUrl }, '', pageUrl);
                }
            })
            .always(function () {
                $section.removeClass('is-loading');
                $results.removeClass('opacity-50');
            });
    }

    $tabs.on('click', function () {
        loadSession($(this), true);
    });

    history.replaceState({ session: initialSession, ajaxUrl: null }, '', location.href);

    window.addEventListener('popstate', function (evt) {
        var state = evt.state;

        if ($section.hasClass('is-loading')) {
            return;
        }

        if (!state || !state.ajaxUrl) {
            applyResults(initialSession, initialHtml);
            return;
        }

        $section.addClass('is-loading');
        $results.addClass('opacity-50');

        $.get(state.ajaxUrl)
            .done(function (html) {
                applyResults(state.session, html);
            })
            .always(function () {
                $section.removeClass('is-loading');
                $results.removeClass('opacity-50');
            });
    });
});
